import createButtonDownload from '../anims/ButtonDownload'

export default class ButtonsDownload {
  constructor() {
    this._getElems()
    this._buttonsDownload()
  }

  _getElems() {
    this.buttons = Array.from(document.querySelectorAll('.c-button-download'))
  }

  _buttonsDownload() {
    if (this.buttons) {
      this.buttons.forEach((button) => {
        createButtonDownload(button)
      })
    }
  }
}
